module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkyOCAxMjhhMzIgMzIgMCAwIDEgMzIgMzJ2NTQ0YTMyIDMyIDAgMCAxLTMyIDMyaC0yNjAuNmw0OS41IDExNS40YTMyIDMyIDAgMCAxLTI5LjQgNDQuNkgzMzYuNWEzMiAzMiAwIDAgMS0yOS40LTQ0LjZMMzU2LjUgNzM2SDk2YTMyIDMyIDAgMCAxLTMyLTMyVjE2MGEzMiAzMiAwIDAgMSAzMi0zMmg4MzJ6TTU5Ny44IDczNmgtMTcxLjZsLTQxLjEgOTZoMjUzLjlsLTQxLjItOTZ6TTg5NiAxOTJIMTI4djQ4MGg3NjhWMTkyeiIgZmlsbD0iIzAiIHAtaWQ9IjIyMTUiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Computer-outlined.svg
// module id = /pnd
// module chunks = 75